import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FaExclamationTriangle, FaLock } from 'react-icons/fa';
import { getActiveRole } from '../utils/permissions';

const Unauthorized = () => {
  const history = useHistory();
  const location = useLocation();
  const customMessage = location.state?.message;

  const handleGoBack = () => {
    history.goBack();
  };

  const handleGoHome = () => {
    const activeRole = getActiveRole();

    // Redirect based on active user role
    if (activeRole === 'HEALTH_CARE_PROVIDER') {
      history.push('/hcp/patient/list');
    } else if (activeRole === 'PATIENT') {
      history.push('/patient/home');
    } else if (activeRole === 'ORG_ADMIN') {
      history.push('/admin/dashboard');
    } else {
      history.push('/user/login');
    }
  };

  return (
    <div className="container-fluid h-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="text-center" style={{ maxWidth: '600px' }}>
        <div className="mb-4">
          <FaLock size={60} className="text-danger mb-3" />
        </div>
        <h1 className="display-4 mb-3 text-dark">403 - Access Denied</h1>
        <p className="lead mb-4 text-secondary">
          {customMessage || "You don't have permission to access this page."}
        </p>
        <p className="text-muted mb-4">
          This page requires specific permissions that are not assigned to your account.
          Please contact your administrator if you believe you should have access to this resource.
        </p>
        <div className="d-flex justify-content-center gap-3">
          <button onClick={handleGoBack} className="btn btn-outline-secondary mr-2 px-4">
            <i className="fa fa-arrow-left"></i> Go Back
          </button>
          <button onClick={handleGoHome} className="btn btn-primary ml-2 px-4">
            <i className="fa fa-home"></i> Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
